export default __webpack_public_path__ + "static/tooltip-info-dont-dark-485055a6a1666bc83c9cbf8f28853973b1cfeded53aa1a41bb8bd2c7470096ae.png";